import { createReducer } from '@reduxjs/toolkit';
import _ from 'lodash';
import { TYPES } from '../../common/constants';

const setLoaderLoadingDone = () => {
    return true
};

const stopLoaderLoadingDone = () => {
    return false
}




const initialState = false;

export default createReducer(initialState, {
  [TYPES.SET_LOADER_LOADING]: setLoaderLoadingDone,
  [TYPES.STOP_LOADER_LOADING]: stopLoaderLoadingDone,
});
